import React, { CSSProperties } from 'react';
import DateRangePicker from '../../../components/daterangepicker/DateRangePicker';
import { DashboardFilters } from '../../../utils/constant';
import { Box, SelectChangeEvent } from '@mui/material';
import { TextField } from 'src/components/new/inputs/TextField';
import SearchIcon from '@mui/icons-material/Search';
import Select from 'src/components/new/inputs/Select';
import ServiceBadge from 'src/components/service-badge/ServiceBadge';
interface JobHistoryFiltersProps {
  noticeTypes: { id: string; label: string }[];
  statuses: { id: string; label: string }[];
  printGenStatuses: { id: string; label: string }[];
  serviceOptions: { id: string; label: string }[];
  selectedFilters: DashboardFilters;
  onFilterChange: (event: SelectChangeEvent<string | (string | null)[]>) => void;
  handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchTerm: string;
  isCosMember: boolean;
}

const wrapperDivStyles: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '0.625rem',
  width: '100%',
};

interface FilterConfigItem {
  id: string;
  data: { id: string; label: string }[];
  label: string;
  placeholder: string;
  width: string;
  name: string;
  multiple: boolean;
  /** Optional custom renderer for the dropdown option content. */
  renderOptionLabel?: (item: { id: string; label: string }) => React.ReactNode;
}

const JobHistoryFilters: React.FC<JobHistoryFiltersProps> = ({
  noticeTypes,
  statuses,
  printGenStatuses,
  serviceOptions,
  selectedFilters,
  onFilterChange,
  handleSearchChange,
  searchTerm,
  isCosMember,
}) => {
  const filterConfig: FilterConfigItem[] = [
    {
      id: 'type',
      data: noticeTypes,
      label: 'Notice Type',
      placeholder: 'Choose',
      width: '10.625rem',
      name: 'type',
      multiple: false,
    },
    {
      id: 'status',
      data: statuses,
      label: 'Status',
      placeholder: 'Choose',
      width: '10.625rem',
      name: 'status',
      multiple: true,
    },
    {
      id: 'service',
      data: serviceOptions,
      label: 'Job Service',
      placeholder: 'Choose',
      width: '10.625rem',
      name: 'service',
      multiple: true,
      renderOptionLabel: (item: { id: string; label: string }) => <ServiceBadge service={item.id} />,
    },
    ...(isCosMember
      ? [
          {
            id: 'printGenStatus',
            data: printGenStatuses,
            label: 'Generation Status',
            placeholder: 'Choose',
            width: '10.625rem',
            name: 'printGenStatus',
            multiple: false,
          },
        ]
      : []),
  ];

  return (
    <div style={wrapperDivStyles}>
      <Box sx={{ marginRight: '0.625rem' }}>
        <TextField
          value={searchTerm}
          onChange={handleSearchChange}
          name="search"
          id="search"
          label={
            <span style={{ fontWeight: 500 }}>
              Search by{' '}
              <span style={{ textDecoration: 'underline', fontWeight: 700 }}>J</span>
              ob Number,{' '}
              <span style={{ textDecoration: 'underline', fontWeight: 700 }}>C</span>
              ase{' '}
              <span style={{ textDecoration: 'underline', fontWeight: 700 }}>N</span>
              umber,{' '}
              <span style={{ textDecoration: 'underline', fontWeight: 700 }}>D</span>
              ebtor
            </span>
          }
          error=""
          endAdornment={<SearchIcon sx={{ color: '#6D7176', marginLeft: '-2rem' }} />}
        />
      </Box>
      <div>
        <DateRangePicker
          value={[selectedFilters.createdAt_start, selectedFilters.createdAt_end].map((date) =>
            date ? new Date(date) : null,
          )}
          onChange={onFilterChange}
        />
      </div>
      {filterConfig.map(({ id, data, width, label, placeholder, name, multiple, renderOptionLabel }) => (
        <div key={id} style={{ display: 'flex', flexDirection: 'column' }}>
          <Select
            key={id}
            data={data}
            label={label}
            name={name}
            onChange={onFilterChange}
            value={selectedFilters[id as keyof typeof selectedFilters] ?? ''}
            error=""
            width="9.375rem"
            disabled={false}
            multiple={multiple}
            placeholder={placeholder}
            renderOptionLabel={renderOptionLabel}
          />
        </div>
      ))}
    </div>
  );
};

export default JobHistoryFilters;
